import { useParams } from 'react-router-dom';

import { Flow_Types } from '@occc-app/offerHelpers/types';

import { MessagingCampaignConfigurePage } from './messaging-campaign-configure.page';
import { getPageLinks as getCreatePageLinks } from './utils/get-page-links.utils';
import { useGetContainerProps } from './hooks/use-get-container-props.hook';

const getBreadcrumbLinks = () => getCreatePageLinks('New Messaging Campaign');
const containerParams = { getBreadcrumbLinks };

export const MessagingCampaignConfigureContainer = () => {
  const { id: campaignId = '' } = useParams<{
    id: string;
  }>();

  const {
    layoutProps,
    configureFormProps,
    targetFormProps,
    scheduleFormProps,
    dialogProps,
    breadcrumbLinks,
    pageTitle,
    pageSubtitle,
  } = useGetContainerProps({ ...containerParams, campaignId, flowType: Flow_Types.Configure });

  return (
    <MessagingCampaignConfigurePage
      layoutProps={layoutProps}
      dialogProps={dialogProps}
      pageTitle={pageTitle}
      subtitle={pageSubtitle}
      configureFormProps={configureFormProps}
      targetFormProps={targetFormProps}
      scheduleFormProps={scheduleFormProps}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
